import { render, staticRenderFns } from "./checkbox-block.html?vue&type=template&id=6d4b9ca7&scoped=true&"
import script from "./checkbox-block.js?vue&type=script&lang=js&"
export * from "./checkbox-block.js?vue&type=script&lang=js&"
import style0 from "./checkbox-block.scss?vue&type=style&index=0&id=6d4b9ca7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4b9ca7",
  null
  
)

export default component.exports